/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const objectiveSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  organizationId: z.string(),
  title: z.string(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
